

export const DATA_TABLE_ROW_INDICATOR = {
  NOT_ACTIVE: 'indicator-not-active',
  WARNING: 'indicator-warning',
  NONE: ''
};